<template>
  <v-theme-provider :dark="dark">
    <div v-if="businessContactInfo">
      <base-business-contact
        :title="businessContactInfo.fields.title"
        :contacts="businessContactInfo.fields.businessContacts"
        dense
      >
        <rich-text-renderer :document="businessContactInfo.fields.intro" />
      </base-business-contact>
    </div>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'BaseBusinessContactInfo',

    props: { dark: Boolean },

    data () {
      return {
        businessContactInfo: null,
      }
    },

    async mounted () {
      const { items } = await this.$contentful.getEntries({
        content_type: 'businessContactInfo',
        select: 'fields',
      })
      const [entry] = items
      this.businessContactInfo = entry
    },
  }
</script>
